import dayjs from 'dayjs';

export function toCalendarInputDate(value?: string | null): string {
  if (!value) {
    return '';
  }

  const rawValue = String(value).trim();
  if (!rawValue) {
    return '';
  }

  const isoDateMatch = rawValue.match(/^(\d{4}-\d{2}-\d{2})/);
  if (isoDateMatch) {
    return isoDateMatch[1];
  }

  const parsed = dayjs(rawValue);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
}

export function toStudyDateRequestValue(value?: string | null): string | null {
  const normalized = toCalendarInputDate(value);
  if (!normalized) {
    return null;
  }

  const parsed = dayjs(normalized, 'YYYY-MM-DD', true);
  if (!parsed.isValid()) {
    return null;
  }

  return new Date(
    Date.UTC(parsed.year(), parsed.month(), parsed.date(), 12, 0, 0, 0)
  ).toISOString();
}
